module.exports = __webpack_public_path__ + "static/11-Creche-e272ad8491ead36401aade125de6fac2.jpg";